export const HEADERS = [
	'Number of callings',
	'Number not pick up',
	'Real time calling',
	'CaloudTalk time calling',
];
